import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import DepositSubDetailForm from "./DepositSubDetailForm";
import "./OnlineDeposit.css";
import * as Yup from "yup";

function OnlineDeposit({ getCompanyAccount }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [cmdCustomerCodeOptions, setcmdCustomerCodeOptions] = useState([]);
    const [roleOptions, setroleOptions] = useState([]);
    const [userTypeOptions, setuserTypeOptions] = useState([]);
    const [depositReferenceDetails, setdepositReferenceDetails] = useState([]);
    const [depositSubDetails, setdepositSubDetails] = useState([]);
    const [fileDetailId, setfileDetailId] = useState([]);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [editRowData, seteditRowData] = useState(false);

    let currentDate = new Date();
    const offset = currentDate.getTimezoneOffset();
    currentDate = new Date(currentDate.getTime() - offset * 60 * 1000);
    const dateVal = currentDate.toISOString().split("T")[0];
    const dateString = dateVal.toString();

    useEffect(() => {
        handleGetRequest("/zbizgateway/lov/lovAuthCompany").then((res) => {
            setcmdCustomerCodeOptions(res?.data);
        });
    }, []);

    const handleProduct = (companydata) => {
        if (companydata?.id !== undefined) {
            formik.setFieldValue("customerDescription", companydata?.description);
            handleGetRequest("/zbizgateway/lov/lovAuthCompanyProduct/" + companydata?.id).then((res) => {
                setroleOptions(res?.data);
            });
        }
    };

    useEffect(() => {
        handleGetRequest("/zbizgateway/lov/lovUserType").then((res) => {
            setuserTypeOptions(res?.data);
        });
    }, []);

    const productCodeTemplateOptions = (option) => {
        return <span>{option?.code + " ---- " + option?.description}</span>;
    };

    const productCodeTemplateValue = (option) => {
        if (option?.code !== undefined) {
            return <span>{option?.code + " ---- " + option?.description}</span>;
        } else return <span>Select Product Code</span>;
    };

    const handleDepositSlipNo = (e) => {
        e.preventDefault();
        setdepositSubDetails([]);
        const data = {
            invoiceNo: formik.values?.depositSlipNo,
            companyId: formik.values?.companyId?.id,
            productId: formik.values?.productId?.id,
        };
        if (data?.companyId !== undefined && data?.productId !== undefined && data?.invoiceNo !== undefined) {
            handlePostRequest(data, "zbizgateway/fin/collection/branchInvoiceInq").then((res) => {
                if (res?.data?.resultmap !== undefined && res?.data?.resultmap?.length !== null) {
                    const orderedData = Object.keys(res?.data?.resultmap)
                        .sort()
                        .reverse()
                        .reduce((obj, key) => {
                            obj[key] = res?.data?.resultmap[key];
                            return obj;
                        }, {});
                    setdepositReferenceDetails([orderedData]);
                    setfileDetailId(res?.data?.fileDetailId);
                }
            });
        } else toast.warn("Please fill Product Code, CMD Customer Code and Deposit Slip No");
    };

    const getProductValue = (product) => {
        formik.setFieldValue("accountId", product?.shortText);
    };

    const handleAddNewSubDetails = (e) => {
        e.preventDefault();
        setDisplaySubDetailsModal(true);
        seteditRowData(false);
    };

    const createId = () => {
        let id = "";
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    };

    const SetSubDetailsData = (data) => {
        let _details = depositSubDetails;
        let _detail = data;
        _detail.id = createId();
        _details.push(_detail);
        setdepositSubDetails(_details);
        setDisplaySubDetailsModal(false);
    };

    const SubDetailsBankCodeBody = (rowData) => {
        return <span>{rowData?.branchId?.code + " -- " + rowData?.branchId?.description}</span>;
    };

    const handleDelteSubDetails = (rowData) => {
        let _details = depositSubDetails;
        let _detail = rowData;
        _details = _details.filter((item) => item.id !== _detail.id);
        setdepositSubDetails(_details);
    };

    const handleEditSubDetails = (data) => {
        let _details = depositSubDetails;
        let _detail = data;
        _details = _details.map((item) => {
            if (item.id === _detail.id) {
                item.branchId = _detail.branchId;
                item.chequeNo = _detail.chequeNo;
                item.chequeAmount = _detail.chequeAmount;
                item.chequeDate = _detail.chequeDate;
            }
            return item;
        });
        setdepositSubDetails(_details);
        setDisplaySubDetailsModal(false);
    };

    const actionBody = (rowData) => {
        return (
            <div>
                <Button
                    className="pi pi-pencil"
                    onClick={() => {
                        setDisplaySubDetailsModal(true);
                        seteditRowData(rowData);
                    }}
                />
                <Button
                    className="p-ml-2 pi pi-trash"
                    onClick={() => {
                        handleDelteSubDetails(rowData);
                    }}
                />
            </div>
        );
    };

    const validationSchema = Yup.object().shape({
        companyId: Yup.mixed().required("This field is required."),
        productId: Yup.mixed().required("This field is required."),
        userTypeId: Yup.mixed().required("This field is required."),
        depositSlipNo: Yup.string().required("This field is required."),
        depositSlipAmount: Yup.string().required("This field is required."),
        noOfInvoices: Yup.string().required("This field is required."),
        depositorEmail: Yup.string().email("Invalid email address format").required("This field is required."),
        depositorCellNo: Yup.string().required("This field is required.").matches("^[0-9]*$", "Please enter numeric data"),
        mobileNo: Yup.string().matches("^[0-9]*$", "Please enter numeric data").min(11, "Minimum length 11 allowed").max(11, "Maximum length 11 allowed"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            userTypeId: "",
            customerDescription: "",
            depositDate: dateString,
            depositSlipNo: "",
            noOfCheques: "",
            noOfInvoices: "",
            depositorCellNo: "",
            depositorEmail: "",
            accountId: "",
            productId: "",
            companyId: "",
            depositSlipAmount: "",
            mobileNo: "",
            docNo: "",
            docType: "",
        },
        onSubmit: async (data) => {
            if (fileDetailId !== undefined) {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                if (depositSubDetails.length !== 0) {
                    const _data = depositSubDetails.map((item) => {
                        return {
                            ...item,
                            branchId: item?.branchId?.id,
                        };
                    });
                    data["branchOnlineDepositDetails"] = _data;
                }
                data["userTypeId"] = data?.userTypeId?.id;
                data["productId"] = data?.productId?.id;
                data["companyId"] = data?.companyId?.id;
                data["fileDetailId"] = fileDetailId;
                await handlePostRequest(data, "zbizgateway/fin/collection/branchOnlineDeposit");
                setloading(false);
                setloadingIcon("pi pi-save");
                getCompanyAccount();
                // formik.resetForm();
            } else toast.warn("Please fill Deposit Slip No");
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Online Deposit</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="companyId" className={classNames({ "p-error": isFormFieldValid("baseLocation") }, "Label__Text")}>
                                    CMD Customer Code<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="companyId"
                                    options={cmdCustomerCodeOptions}
                                    placeholder="Enter customer code"
                                    optionLabel="code"
                                    name="companyId"
                                    value={formik.values.companyId}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        handleProduct(e.target.value);
                                    }}
                                    className={classNames({ "p-invalid": isFormFieldValid("companyId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("companyId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="customerDescription" className={classNames({ "p-error": isFormFieldValid("customerDescription") }, "Label__Text")}>
                                    Customer
                                </label>
                                <InputText id="customerDescription" disabled name="customerDescription" value={formik.values.customerDescription} className={classNames({ "p-invalid": isFormFieldValid("customerDescription") }, "Input__Round")} />
                                {getFormErrorMessage("customerDescription")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="productId" className={classNames({ "p-error": isFormFieldValid("productId") }, "Label__Text")}>
                                    Product Code<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="productId"
                                    itemTemplate={productCodeTemplateOptions}
                                    valueTemplate={productCodeTemplateValue}
                                    placeholder="Select Code"
                                    options={roleOptions}
                                    optionLabel="description"
                                    name="productId"
                                    value={formik.values.productId}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        getProductValue(e.target.value);
                                    }}
                                    className={classNames({ "p-invalid": isFormFieldValid("productId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("productId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="accountId" className={classNames({ "p-error": isFormFieldValid("accountId") }, "Label__Text")}>
                                    Collection A/C No.
                                </label>
                                <InputText id="accountId" name="accountId" disabled value={formik.values.accountId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("accountId") }, "Input__Round")} />
                                {getFormErrorMessage("accountId")}
                            </div>
                        </div>

                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="userTypeId" className={classNames({ "p-error": isFormFieldValid("userTypeId") }, "Label__Text")}>
                                    Payment Mode Code<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="userTypeId"
                                    placeholder="Enter payment code"
                                    options={userTypeOptions}
                                    optionLabel="description"
                                    name="userTypeId"
                                    value={formik.values.userTypeId}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("userTypeId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("userTypeId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <label htmlFor="depositDate" className="Label__Text">
                                Deposit Date
                            </label>
                            <InputText id="depositDate" type="date" name="depositDate" format="yyy-MM-dd" value={formik.values.depositDate} onChange={formik.handleChange} className="Input__Round" />
                            {getFormErrorMessage("depositDate")}
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="depositSlipNo" className={classNames({ "p-error": isFormFieldValid("depositSlipNo") }, "Label__Text")}>
                                    Deposit Slip Number<span className="Label__Required">*</span>
                                </label>
                                <div className="p-d-flex Search__Round">
                                    <InputText id="depositSlipNo" placeholder="Enter slip number" name="depositSlipNo" value={formik.values.depositSlipNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("depositSlipNo") }, "Input__Round")} />
                                    <Button icon="pi pi-search" onClick={(e) => handleDepositSlipNo(e)} className="p-button-rounded p-button-success p-button-text" />
                                </div>
                                {getFormErrorMessage("depositSlipNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="depositSlipAmount" className={classNames({ "p-error": isFormFieldValid("depositSlipAmount") }, "Label__Text")}>
                                    Deposit Slip Amount<span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    id="depositSlipAmount"
                                    placeholder="Enter slip amount"
                                    type="number"
                                    name="depositSlipAmount"
                                    value={formik.values.depositSlipAmount}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("depositSlipAmount") }, "Input__Round")}
                                />

                                {getFormErrorMessage("depositSlipAmount")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="noOfCheques" className={classNames({ "p-error": isFormFieldValid("noOfCheques") }, "Label__Text")}>
                                    Total No. of Cheques
                                </label>
                                <InputText id="noOfCheques" placeholder="Enter no of cheques" name="noOfCheques" value={formik.values.noOfCheques} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("noOfCheques") }, "Input__Round")} />

                                {getFormErrorMessage("noOfCheques")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="noOfInvoices" className={classNames({ "p-error": isFormFieldValid("noOfInvoices") }, "Label__Text")}>
                                    No. of Invoices<span className="Label__Required">*</span>
                                </label>
                                <InputText id="noOfInvoices" placeholder="Enter invoice no" name="noOfInvoices" value={formik.values.noOfInvoices} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("noOfInvoices") }, "Input__Round")} />

                                {getFormErrorMessage("noOfInvoices")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="depositorCellNo" className={classNames({ "p-error": isFormFieldValid("depositorCellNo") }, "Label__Text")}>
                                    Depositor's Cell No.<span className="Label__Required">*</span>
                                </label>
                                <InputText id="depositorCellNo" placeholder="Enter cell no" name="depositorCellNo" value={formik.values.depositorCellNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("depositorCellNo") }, "Input__Round")} />

                                {getFormErrorMessage("depositorCellNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="depositorEmail" className={classNames({ "p-error": isFormFieldValid("depositorEmail") }, "Label__Text")}>
                                    Depositor's Email<span className="Label__Required">*</span>
                                </label>
                                <InputText id="depositorEmail" placeholder="Enter email" name="depositorEmail" value={formik.values.depositorEmail} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("depositorEmail") }, "Input__Round")} />

                                {getFormErrorMessage("depositorEmail")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="mobileNo" className={classNames({ "p-error": isFormFieldValid("mobileNo") }, "Label__Text")}>
                                    Mobile Number.
                                </label>
                                <InputText id="mobileNo" placeholder="Enter mobile no" name="mobileNo" value={formik.values.mobileNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("mobileNo") }, "Input__Round")} type="number" />
                                {getFormErrorMessage("mobileNo")}
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className="Down__Btn">
                <Button onClick={(e) => handleAddNewSubDetails(e)} label="Add New" className="Btn__Dark" />
            </div>

            <div className="card p-datatable-sm">
                <DataTable header="Deposit Sub Details" loading={loading} paginator rows={5} value={depositSubDetails} emptyMessage="">
                    <Column field="branchId.description" body={SubDetailsBankCodeBody} header="Bank Code" />
                    <Column field="chequeNo" header="Cheque No." />
                    <Column field="chequeAmount" header="Cheque Amount" />
                    <Column field="chequeDate" header="Cheque Date" />
                    <Column body={actionBody} header="" />
                </DataTable>
            </div>

            <div className="card">
                <div className="header__custom">
                    <h2 className="header__heading_custom">Deposit Reference Details</h2>
                </div>

                <table className="table__custom">
                    <tr>
                        {depositReferenceDetails.length > 0 &&
                            Object.keys(depositReferenceDetails?.[0]).map((key) => {
                                return (
                                    <>
                                        <th className="th__custom">{key}</th>
                                    </>
                                );
                            })}
                    </tr>
                    <tr>
                        {depositReferenceDetails.length > 0 &&
                            Object.values(depositReferenceDetails?.[0]).map((data) => {
                                return (
                                    <>
                                        <td className="td_custom">{data}</td>
                                    </>
                                );
                            })}
                    </tr>
                </table>
                <br />
                <div className="Down__Btn">
                    <Button label="Reset" className="Btn__Transparent" />
                    <Button disabled={loading} icon={loadingIcon || ""} onClick={formik.handleSubmit} iconPos="right" label="Submit" className="Btn__Dark" />
                </div>
            </div>

            <Dialog visible={displaySubDetailsModal} style={{ width: "50vw" }} onHide={() => setDisplaySubDetailsModal(false)}>
                <DepositSubDetailForm SetSubDetailsData={SetSubDetailsData} editRowData={editRowData} handleEditSubDetails={handleEditSubDetails} />
            </Dialog>
        </>
    );
}

export default OnlineDeposit;
